import { useLanguage } from "@/context/LanguageContext";
import { Chapter, Reveal, CropMarks } from "@/components/atoms";

export const MoreProjects = () => {
  const { t } = useLanguage();
  const m = t.moreProjects;
  return (
    <section className="border-t border-hairline" data-testid="more-projects-section">
      <div className="px-5 md:px-10 pt-20 md:pt-28 pb-10 md:pb-14">
        <Reveal>
          <Chapter num={m.chapter} label={m.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif font-light tracking-tight leading-none text-4xl sm:text-5xl md:text-6xl" data-testid="more-projects-headline">
            {m.headline}
          </h2>
        </Reveal>
      </div>
      <div className="border-t border-hairline">
        {m.items.map((item, i) => (
          <Reveal key={i} delay={0.06 * i}>
            <div className="grid md:grid-cols-12 gap-6 md:gap-10 px-5 md:px-10 py-10 md:py-12 border-b border-hairline items-center" data-testid={`more-project-${i}`}>
              <div className="md:col-span-4">
                <span className="font-mono text-[11px] tracking-[0.25em] text-proof">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-3 font-serif text-2xl md:text-3xl tracking-tight leading-tight">{item.title}</h3>
              </div>
              <p className={`text-base md:text-lg font-light leading-relaxed text-ink/80 ${item.image ? "md:col-span-6" : "md:col-span-8"}`}>
                {item.text}
              </p>
              {item.image && (
                <div className="md:col-span-2">
                  <div className="relative border border-ink/25 bg-cardboard overflow-hidden aspect-[3/4] max-w-[140px]">
                    <img src={item.image} alt={item.imageLabel} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
                    <CropMarks className="text-paper/70 z-10" />
                  </div>
                </div>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
